const registrationReq = {
  pageTitle: "طلبات التسجيل",
  reject: "رفض",
  listBreadcrumb: "طلبات التسجيل",
  searchPlaceholder: "البحث عن الشركات",
  companyNameEn: "اسم الشركة (إنجليزي)",
  companyNameAr: "اسم الشركة (عربي)",
  commercialRecord: "السجل التجاري",
  creationDate: "تاريخ الإنشاء",
  rejectModalTitle: "رفض طلب التسجيل",
  rejectModalDescription:
    "يُرجى ذكر سبب رفض {name}. سيتم إرسال ذلك إلى الشركة عبر البريد الإلكتروني.",
  rejectionReasonLabel: "سبب الرفض",
  required: "مطلوب",
  rejectionReasonMinLength: "يُرجى إدخال 3 أحرف على الأقل.",
  rejectionReasonPlaceholder: "أدخل سبب الرفض...",
  confirmRejection: "تأكيد الرفض",
  emptyPendingTitle: "لا توجد طلبات تسجيل معلّقة.",
  emptyRejectedTitle: "لا توجد طلبات تسجيل مرفوضة.",
  noDataDescription: "لا توجد طلبات تسجيل معلّقة.",

  backToRegistrationRequests: "العودة إلى طلبات التسجيل",
  companyOverallSatisfaction: "رضا الشركة الإجمالي",
  companySatisfactionPeriod: "كل الفترات",
  companyInformation: "معلومات الشركة",
  contactPerson: "الشخص المسؤول",
  documents: "المستندات",
  pdfPreview: "معاينة PDF",
  documentViewer: "عارض المستندات",
  viewerPageOf: "من",
  viewerPreviousPage: "الصفحة السابقة",
  viewerNextPage: "الصفحة التالية",
  viewerUnsupportedWord:
    "معاينة ملفات Word غير متاحة في المتصفح. قم بتنزيل الملف لفتحه.",
  previewPdfHint: "اضغط «معاينة» على أي مستند لعرضه هنا.",
  closeViewer: "إغلاق العارض",
  preview: "معاينة",
  download: "تنزيل",
  englishName: "الاسم بالإنجليزية",
  arabicName: "الاسم بالعربية",
  city: "المدينة",
  fullName: "الاسم الكامل",
  mobileNumber: "رقم الجوال",
  emailAddress: "البريد الإلكتروني",
  approveRegistration: "قبول التسجيل",
  rejectRegistration: "رفض التسجيل",
  statusPendingApproval: "بانتظار الموافقة",
  statusApproved: "تمت الموافقة",
  statusRejected: "مرفوض",
  companyDetailsLoadError: "تعذّر تحميل بيانات الشركة. يُرجى المحاولة مرة أخرى.",
  retry: "إعادة المحاولة",
  commercialRecordDocument: "السجل التجاري",
  delegationDocument: "خطاب التفويض",
  idDocument: "نسخة الهوية",
};

export default registrationReq;
